/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function MagnifyingGlassIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M27.011 16.987c0-3.559-1.938-6.805-5.002-8.616-3.127-1.811-6.941-1.811-10.005 0C8.877 10.18 7 13.428 7 16.987c0 3.622 1.876 6.869 5.003 8.68 3.064 1.81 6.878 1.81 10.005 0 3.064-1.811 5.002-5.058 5.002-8.68m-1.938 10.24a13.1 13.1 0 0 1-8.067 2.748C9.816 29.975 4 24.168 4 16.987 4 9.87 9.815 4 17.006 4c7.129 0 13.007 5.87 13.007 12.987 0 3.06-1.063 5.87-2.814 8.117l8.379 8.305c.563.624.563 1.56 0 2.123-.625.624-1.563.624-2.126 0z"/>}
        </IconWrapper>);
}
